export const commonConstant = {
    aminities:'1,2,3,52,31,4,5,6,7,13,18,19,20,23,30,32,35,43',
    nameRegex: /^[\p{L}\s'-]+$/u,
    companyRegex: /^[A-Za-z0-9\s\-_]+$/,
    limit: 20,
    radius: 15,
    defaultLocation:{
        latitude: 30.0507827,
        longitude: 31.237413,
    },
    /* eslint-disable @typescript-eslint/quotes */
    emailRegex:
        /^(([^<>()\[\]\\.\\,;:\s@"]+(\.[^<>()\[\]\\.\\,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}))$/
    /* eslint-enable @typescript-eslint/quotes */,
    distanceFromBottomForDesktop: 300,
    distanceFromBottomForMobile: 700,
    idleTime: 0,
    oneSecInterval: 1000,
    maxTitleLength: 26
};
